import { HStack, Icon, Kbd, Text, VStack } from '@chakra-ui/react';

import {
  PALETTE_COLORS,
  PALETTE_SIZES,
  PALETTE_SPACING,
  PALETTE_TRANSITIONS,
} from '../../constants';

import { CommandItemProps } from './CommandItem.types';

function CommandItem({ command, index, isSelected, onSelect, onClick, itemRef }: CommandItemProps) {
  return (
    <HStack
      role="button"
      tabIndex={0}
      ref={itemRef}
      p={PALETTE_SPACING.itemPadding}
      spacing={PALETTE_SPACING.itemSpacing}
      cursor="pointer"
      bg={isSelected ? PALETTE_COLORS.selectedBg : PALETTE_COLORS.transparent}
      _hover={{ bg: PALETTE_COLORS.selectedBg }}
      onClick={() => onClick(index)}
      onMouseEnter={() => onSelect(index)}
      borderLeft={
        isSelected
          ? `${PALETTE_SIZES.borderWidth} solid`
          : `${PALETTE_SIZES.borderWidth} solid transparent`
      }
      borderLeftColor={isSelected ? PALETTE_COLORS.selected : PALETTE_COLORS.transparent}
      transition={PALETTE_TRANSITIONS.default}
    >
      {command.icon && (
        <Icon
          as={command.icon}
          boxSize={PALETTE_SIZES.iconSize}
          color={isSelected ? PALETTE_COLORS.selected : PALETTE_COLORS.textSecondary}
        />
      )}
      <VStack align="start" spacing="2px" flex={1}>
        <Text
          fontSize={PALETTE_SIZES.fontSize}
          fontWeight={isSelected ? '600' : '500'}
          color={isSelected ? PALETTE_COLORS.selected : PALETTE_COLORS.text}
        >
          {command.label}
        </Text>
        {command.description && (
          <Text fontSize={PALETTE_SIZES.fontSizeSmall} color={PALETTE_COLORS.textSecondary}>
            {command.description}
          </Text>
        )}
      </VStack>
      {command.shortcut && (
        <Kbd fontSize={PALETTE_SIZES.fontSizeSmall} px={PALETTE_SIZES.kbdPadding} py="2px">
          {command.shortcut}
        </Kbd>
      )}
    </HStack>
  );
}

export default CommandItem;
